export default "__VITE_ASSET__3acc7003__"